// src/components/dashboard/ElectricityExplainerCard.js
import React, { useMemo } from "react";
import { useElectricityGenTS } from "../../hooks/useElectricityGenTS";

export default function ElectricityExplainerCard({
  scenario,
  year = 2025,
  unitScale = 0.277778, // PJ -> TWh (keep in sync with the hook)
}) {
  // Ask the TS hook for a single year window (from=to=year)
  const { labels, totalsByYear, loading, error } = useElectricityGenTS({
    scenario,
    year,        // shorthand; inside the hook this sets from=to=year
    unitScale,   // scaling happens once inside the hook
  });

  // Pick the single-year total (first/only point)
  const totalTWh = useMemo(() => {
    if (!totalsByYear?.length) return 0;
    return Number(totalsByYear[0]) || 0;
  }, [totalsByYear]);

  if (loading) {
    return (
      <div className="mt-12 p-3 rounded-lg text-xs text-gray-500">
        Loading electricity total for {year}…
      </div>
    );
  }

  if (error) {
    return (
      <div className="mt-12 p-3 rounded-lg text-xs text-red-600">
        Couldn’t load electricity total for {year}: {error.message}
      </div>
    );
  }

  const display = Math.round(totalTWh);
  const note = labels?.length ? "" : " (no rows found; showing 0)";

  return (
    <div className="mt-12 p-3 rounded-lg">
      <h4 className="text-lg font-medium text-black mb-2">
        What Could All That Electricity Actually Do?
      </h4>
      <p className="text-m text-gray-600 mb-3 italic">

        {/* The UK generates {display.toLocaleString()} TWh of electricity in {year} */}
       Reducing energy demand means that we need to generate less electricity (so fewer new nuclear power stations, wind farms, solar farms, energy storage facilities and pylons). It also means that we won't need to rely on fossil fuels and unstable international energy markets for as long. The comparisons below show some everyday examples of how much electricity would be needed in different scenarios, compared to 2025. This gives you an idea of the scale of the difference between them.
      </p>
    </div>
  );
}
